import {NgModule} from '@angular/core';
import {CommandService} from '@core/services/command.service';
import {OICReturnsHandler} from '@features/oic/services/handlers/oic-returns.handler';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {CdkTableModule} from '@angular/cdk/table';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatStepperModule} from '@angular/material/stepper';
import {FuseSharedModule} from '@barebone-fuse/@fuse/shared.module';
import {FuseSearchBarModule} from '@barebone-fuse/@fuse/components';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatSelectModule} from '@angular/material/select';
import {MatDividerModule} from '@angular/material/divider';
import {MatTableModule} from '@angular/material/table';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {FormsModule} from '@angular/forms';
import {MatTooltipModule} from '@angular/material/tooltip';
import {SharedModule} from '@shared/shared.module';
import {CoreModule} from '@core/core.module';
import {PlatformApiProvider} from '@shared/services/platform-api-provider';
import {StartWorkFlowCommandHandler} from '@features/audit-tracker/services/command-handlers/start-work-flow-command-handler';
import {OicDynamicComponentHelper} from '@features/oic/oic-dynamic-component-helper';
import {PlatformCommand} from '@shared/commands/command-base';
import {oicRoutes} from '@features/oic/oic.routes';
import {SelectDefaultTemplateDialogComponent} from './components/select-default-template-dialog/select-default-template-dialog.component';
import {SelectDefaultTemplateForAdfPipelineCommandHandler} from '@features/oic/services/command-handler/select-default-template-for-adf-pipeline-command-handler';
import {SetOICFlowTemplateCommandHandler} from '@features/oic/services/command-handler/set-oic-flow-template-command-handler.service';
import {PauseResumeOicWorkFlowsCommandHandler} from '@features/oic/services/command-handler/pause-resume-workflow-command-handler';
import {PauseResumeOicWorkflowDialogComponent} from '@features/oic/components/pause-resume-oic-workflow-dialog/pause-resume-oic-workflow-dialog.component';
import { PeopleAndRolesDialogueComponent } from './components/people-and-roles-dialogue/people-and-roles-dialogue.component';
import {OpenPeopleAndRolesDialogueCommandHandler} from '@features/oic/services/command-handler/open-people-and-roles-dialogue-command-handler';
import { ViewAnalyticsEatWorkflowComponent } from './components/view-analytics-eat-workflow/view-analytics-eat-workflow.component';
import {ContactsModule} from '@features/contacts/contacts.module';


@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(oicRoutes),
    CdkTableModule,
    MatSidenavModule,
    MatButtonModule,
    MatIconModule,
    MatToolbarModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatStepperModule,
    FuseSharedModule,
    FuseSearchBarModule,
    MatMenuModule,
    MatButtonToggleModule,
    MatSelectModule,
    MatDividerModule,
    MatTableModule,
    MatPaginatorModule,
    MatDatepickerModule,
    MatProgressSpinnerModule,
    FormsModule,
    MatTooltipModule,
    SharedModule,
    CoreModule,
    ContactsModule
  ],
  declarations: [
    SelectDefaultTemplateDialogComponent,
    PauseResumeOicWorkflowDialogComponent,
    PeopleAndRolesDialogueComponent,
    ViewAnalyticsEatWorkflowComponent
  ],
  providers: []
})
export class OicModule {
  constructor(private commandService: CommandService,
              private oICReturnsHandler: OICReturnsHandler,
              private platformApiProvider: PlatformApiProvider,
              private startWorkFlowCommandHandler: StartWorkFlowCommandHandler,
              private selectDefaultTemplateForAdfPipelineCommandHandler: SelectDefaultTemplateForAdfPipelineCommandHandler,
              private setWorkFlowForOICDataCommandHandler: SetOICFlowTemplateCommandHandler,
              private pauseResumeOicWorkFlowsCommandHandler: PauseResumeOicWorkFlowsCommandHandler,
              private openPeopleAndRolesDialogueCommandHandler: OpenPeopleAndRolesDialogueCommandHandler
  ) {
    OicDynamicComponentHelper.init();
    OicDynamicComponentHelper.register('OICReturnsHandler', oICReturnsHandler);
    OicDynamicComponentHelper.register('StartWorkFlowCommandHandler', startWorkFlowCommandHandler);
    OicDynamicComponentHelper.register('SelectDefaultTemplateForADFPipelineCommandHandler', selectDefaultTemplateForAdfPipelineCommandHandler);
    OicDynamicComponentHelper.register('SetOICFlowTemplateCommandHandler', setWorkFlowForOICDataCommandHandler);
    OicDynamicComponentHelper.register('PauseResumeOicWorkFlowsCommandHandler', pauseResumeOicWorkFlowsCommandHandler);
    OicDynamicComponentHelper.register('OpenPeopleAndRolesDialogueCommandHandler', openPeopleAndRolesDialogueCommandHandler)
    const command = new PlatformCommand('OicReturnLinkCommand', 'FlowApi');
    command.projectId = '[PROJECT_ID]';
    this.commandService.registrPlatformLinkCommand('/oic/return', command);

    const oicAnalyticsPlatformCommand = new PlatformCommand('OicAnalyticsLinkCommand', 'FlowApi');
    oicAnalyticsPlatformCommand.projectId = '[PROJECT_ID]';
    oicAnalyticsPlatformCommand.fieldValues['ReportType'] = 'OIC';
    oicAnalyticsPlatformCommand.fieldValues['BreadcrumbText'] = 'OIC~Dashboard';
    oicAnalyticsPlatformCommand.fieldValues['BreadcrumbLink'] = '/oic/dashboard~/oic/dashboard';
    this.commandService.registrPlatformLinkCommand('/oic/dashboard', oicAnalyticsPlatformCommand);
    this.platformApiProvider.registerDefault('FlowApi', '/oic/return');
    this.platformApiProvider.registerDefault('FlowApi', '/oic/dashboard');
    this.platformApiProvider.registerDefault('FileStoreApi','/oic/analytics');

  }
}
